import moment from 'moment';

import { OnHandReportFifoEnum } from 'Common/FieldEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

const DATE = moment();

export const BASE_URL = '/onhandreport';

export const INITIAL_VALUES = {
  [OnHandReportFifoEnum.ItemIds]: [],
  [OnHandReportFifoEnum.ShowAllDates]: true,
  [OnHandReportFifoEnum.FromDt]: DATE.subtract(1, 'month').format(
    DATE_FORMAT_FOR_UI
  ),
  [OnHandReportFifoEnum.ToDt]: DATE.add(2, 'month').format(DATE_FORMAT_FOR_UI),
  [OnHandReportFifoEnum.SiteIds]: [],
};



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/onhandreport/helper/fifo.js